import { h } from './dom';

const fmtCoord = (val: number, pos: 'N' | 'E', neg: 'S' | 'W') =>
  `${Math.abs(val).toFixed(2)}° ${val >= 0 ? pos : neg}`;

interface IpInfo { latitude?: number; longitude?: number; }

async function fillCoordsFromIp(latEl: HTMLElement, lonEl: HTMLElement) {
  try {
    const res = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
    if (!res.ok) return;
    const data = (await res.json()) as IpInfo;
    if (typeof data.latitude === 'number') {
      latEl.textContent = fmtCoord(data.latitude, 'N', 'S');
    }
    if (typeof data.longitude === 'number') {
      lonEl.textContent = fmtCoord(data.longitude, 'E', 'W');
    }
  } catch {
    // network error / blocked / timed out — leave the dashes
  }
}

export function Hero(): HTMLElement {
  const lat = h('b', {}, '—');
  const lon = h('b', {}, '—');
  void fillCoordsFromIp(lat, lon);

  const numbers = h('div', { class: 's-hero__numbers' });
  numbers.append(
    'n° ', h('b', {}, '014'), h('br'),
    'lat ', lat, ' · lon ', lon, h('br'),
    'est. ', h('b', {}, '2024'),
  );

  const lede = h('p', { class: 's-hero__lede' });
  lede.append(
    'One studio. Real engineering. We ship in ',
    h('em', {}, 'TypeScript, Python, Go, and Rust'),
    ' — chosen per problem, not per trend. Frontend through backend, briefs through deployment.',
  );

  return h('section', { class: 's-hero' },
    h('div', { class: 's-hero__blob' }),
    h('div', { class: 's-hero__tag' }, 'available · q4 2026'),
    numbers,
    h('h1', { class: 's-hero__title' },
      h('span', { class: 'ln ln--1' }, 'Build'),
      h('span', { class: 'ln ln--2' }, h('span', { class: 'strike' }, 'damn')),
      h('span', { class: 'ln ln--3' }, h('span', { class: 'good' }, 'good')),
      h('span', { class: 'ln ln--4' }, 'software'),
    ),
    lede,
    h('div', { class: 's-hero__cta-row' },
      h('a', { href: '#contact', class: 's-link' },
        'Start a project ',
        h('span', { class: 's-link__arrow' }, '→'),
      ),
      h('a', { href: '#work', class: 's-link s-link--ghost' },
        'See the work ',
        h('span', { class: 's-link__arrow' }, '↘'),
      ),
    ),
    h('div', { class: 's-hero__corner s-hero__corner--bl' }, 'scroll · 00°'),
  );
}
